import i18n from '../translation'
import _ from 'lodash'
import {LEVEL, DOMAINE} from '../constants'

export const _User = {
  namespaced: true,
  state: {
    listeMessages: [],
    remainingSteps: '',
    installProgress: 0,
    ongoingTuto: false,
    tutoQuited: false
  },
  getters: {
    user: state => state,
    fullName: state => _.trim(state.fname + ' ' + state.lname),
    userAvatar: state => {
      if (state.avatar) {
        if (process.env.NODE_ENV === 'development') {
          return `${DOMAINE}/dev/media/user/small/${state.avatar}`
        } else {
          return `${DOMAINE}/media/user/small/${state.avatar}`
        }
      }
      return null
    },
    account: state => {
      switch (parseInt(state.rights)) {
        case 0:
          return {
            type: i18n.messages[i18n.locale]['accountAgent'],
            role: 'peon',
            rights: parseInt(state.rights)
          }
        case 1:
          return {
            type: i18n.messages[i18n.locale]['accountAgent'],
            role: 'agent',
            rights: parseInt(state.rights)
          }
        case 2:
          return {
            type: i18n.messages[i18n.locale]['accountSuper'],
            role: 'super',
            rights: parseInt(state.rights)
          }
        case 3:
          return {
            type: i18n.messages[i18n.locale]['accountAdmin'],
            role: 'admin',
            rights: parseInt(state.rights)
          }
        case 999:
          return {
            type: i18n.messages[i18n.locale]['accountAdminTf'],
            role: 'adminTF',
            rights: parseInt(state.rights)
          }
        default:
          return {
            type: i18n.messages[i18n.locale]['accountUnknown'],
            role: null,
            rights: parseInt(state.rights)
          }
      }
    },
    level: state => {
      let level = parseInt(state.entLevel)
      switch (level) {
        case LEVEL.HS:
          return {
            title: i18n.messages[i18n.locale]['levelHS'],
            rights: level,
            monitor: 0
          }
        case LEVEL.ESSAI:
          return {
            title: i18n.messages[i18n.locale]['levelEssai'],
            rights: level,
            monitor: 20000
          }
        case LEVEL.START:
          return {
            title: 'Start',
            rights: level,
            monitor: 45000
          }
        case LEVEL.CHAT:
          return {
            title: 'ChatFirst',
            rights: level,
            monitor: 0
          }
        case LEVEL.PRO:
          return {
            title: 'Pro',
            rights: level,
            monitor: 30000
          }
        case LEVEL.ENTREPRISE:
          return {
            title: 'Entreprise',
            rights: level,
            monitor: 20000
          }
        default:
          return null
      }
    },
    /**
     * Retourne la liste des conseillers sans moi
     */
    colleaguesWithoutMe: state => {
      return _.filter(state.colleagues, function (u) { return u.USR_ID !== state.id })
    },
    /**
     * Retourne la liste des bots sans moi
     */
    botsWithoutMe: state => {
      return _.filter(state.bots, function (u) { return u.USR_ID !== state.id })
    },
    getUserById: state => id => {
      const userId = Number.parseInt(id)
      return state.colleagues.find(c => Number.parseInt(c.USR_ID) === userId)
    }
  },
  mutations: {
    setUser (state, newUser) {
      state.id = newUser.id
      state.fname = newUser.fname
      state.lname = newUser.lname
      state.mail = newUser.mail
      state.mailContact = newUser.mailContact
      state.job = newUser.job
      state.phone = newUser.phone
      state.title = newUser.title
      state.avatar = newUser.avatar
      state.entLevel = newUser.entLevel
      state.licSpecialtable = newUser.licSpecialtable
      state.entSF = newUser.entSF
      state.entZD = newUser.entZD
      state.entGA = newUser.entGA
      state.entSlack = newUser.entSlack
      state.user_sites = newUser.user_sites
      state.smsOn = newUser.smsOn
      // state.autoAnswser = newUser.autoAnswser
      // lang à synchro avec le module de lang
      state.lang = newUser.lang
      i18n.locale = newUser.lang
    },
    setAvatar (state, newAvatar) {
      state.avatar = newAvatar
      ? newAvatar + '?' + Math.random()
      : null
    },
    setEntNbPageTotal (state, nb) {
      state.entNbPageTotal = nb
    },
    addColleague (state, colleague) {
      state.colleagues.push(colleague)
    },
    // -------------------------------------------------------------
    // MISE A JOUR DE LA LISTE DES MESSAGES EN ATTENTES
    // -------------------------------------------------------------
    SET_MESSAGE_ATTENTE (state, liste) {
      // console.log('set visiteur', visiteur)
      // console.log('SET_MESSAGE_ATTENTE', liste)
      state.listeMessages = liste
    },
    // -------------------------------------------------------------
    // MISE A JOUR DE L'AVATAR DE LA LISTE DES MESSAGES EN ATTENTES
    // -------------------------------------------------------------
    SET_AVATAR_MESSAGE_ATTENTE (state, data) {
      // console.log('SET_AVATAR_MESSAGE_ATTENTE', data)
      state.listeMessages.splice(data.key, 1, data.visiteurData)
      // state.listeMessages = liste
    },
    // -------------------------------------------------------------
    // MISE A JOUR dDE LA PROGRESSION DE L'UTILISATION DU BO PAR LE CONSEILLER
    // -------------------------------------------------------------
    MAJ_PROGRESSION (state, data) {
      // console.log('MAJ_PROGRESSION', data)
      state.remainingSteps = data.remainingSteps
      state.installProgress += data.installProgress
    },
    // -------------------------------------------------------------
    // LE CONSEILLER EST OU N'EST PAS DANS LE TUTO
    // -------------------------------------------------------------
    ONGOING_TUTO (state, data) {
      state.ongoingTuto = data.ongoingTuto
    },
    // -------------------------------------------------------------
    // LE CONSEILLER QUITTE LE TUTO
    // -------------------------------------------------------------
    QUIT_TUTO (state, data) {
      state.tutoQuited = data.tutoQuited
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js